import React from 'react';
import { ListChecks } from 'lucide-react';
import { AdminPageHeader, AdminGuideCallout } from '../../components/admin/guidance';
import { ADMIN_PAGE_GUIDES } from '../../utils/adminPageGuides';

const AdminContent = () => {
 const guide = ADMIN_PAGE_GUIDES.content;

 return (
 <div className="space-y-5">
 <AdminPageHeader
 title="Content Management"
 subtitle="Moderate and manage site content across the platform."
 />

 <AdminGuideCallout title={guide.title} steps={guide.steps} icon={ListChecks} />

 <div className="product-panel p-4 sm:p-5">
 <p className="text-sm text-ink-secondary">
 Admin content moderation page.
 </p>
 </div>
 </div>
 );
};

export default AdminContent;
